/**
 * Pulls the human-readable error message out of a community action response.
 */
export const getActionErrorMessage = (data: unknown): string | undefined =>
  isActionErrorResponse(data) ? data.toast.message : undefined;

const isActionErrorResponse = (data: unknown): data is { toast: { message: string } } => {
  if (typeof data !== 'object' || data === null || !('toast' in data)) {
    return false;
  }

  const { toast } = data as { toast: unknown };

  return (
    typeof toast === 'object' &&
    toast !== null &&
    'message' in toast &&
    typeof (toast as { message: unknown }).message === 'string' &&
    (toast as { message: string }).message.length > 0
  );
};
